import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../../../components/Header";
import Footer from "../../../../../components/Footer";
import "../../../styleAllServices.css";


import cleanup from "../../../../../assets/img/projects/oneTimeCleanups/backyard-brush-removal-transformation-west-vancouver.jpg";
import softHedge from "../../../../../assets/img/softscape-hedge-landscape.jpg";
import commercialLandscape from "../../../../../assets/img/bh-commercial-landscaping-vancouver.jpg";

export default function PruningShearingCleanup() {
  const location = useLocation();

  // Meta Tag changes
    useEffect(() => {
      const canonicalUrl = `https://bur-han.ca${location.pathname}`;
      const linkTag = document.querySelector('link[rel="canonical"]');
      if (linkTag) {
        linkTag.setAttribute("href", canonicalUrl);
      } else {
        const newLinkTag = document.createElement("link");
        newLinkTag.setAttribute("rel", "canonical");
        newLinkTag.setAttribute("href", canonicalUrl);
        document.head.appendChild(newLinkTag);
      }

    const newTitle = "Pruning & Shearing Services | Landscaping in Vancouver | BUR-HAN";
    document.title = newTitle;

    const newDescription =
      "Enhance curb appeal and plant health with BUR-HAN's expert pruning and shearing services in Vancouver. Precise, professional, and eco-conscious.";
      const descriptionMetaTag = document.querySelector('meta[name="description"]');
      if (descriptionMetaTag) {
        descriptionMetaTag.setAttribute("content", newDescription);
      } else {
        const newMetaTag = document.createElement("meta");
        newMetaTag.setAttribute("name", "description");
        newMetaTag.setAttribute("content", newDescription);
        document.head.appendChild(newMetaTag);
      }

    const newKeywords = [
     "pruning and shearing Vancouver",
  "hedge trimming services",
  "tree and shrub pruning",
  "hedge maintenance Vancouver",
  "shrub shaping and shearing",
  "garden pruning services",
  "landscape trimming Vancouver",
  "plant health pruning"
    ].join(", ");
    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Pruning & Shearing Services</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
        "Enhance the beauty and function of your outdoor space with our expert
       prunning/shearing services."
        </h2>
        <hr />
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right" style={{marginBottom:'-5%'}}>
            <img loading="lazy"
              src={cleanup}
              style={{height:'82%'}}
              alt="Expert pruning of green shrubs in a well-maintained residential landscape in Vancouver"
              title="Professional Shrub Pruning Services in Vancouver"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
               Pruning/Shearing Services
            </h3>
            <p>
  At BUR-HAN Garden & Lawn Care, our expert pruning and shearing services in Vancouver
   are essential for maintaining the health, shape, and visual appeal of your landscape. Whether it's ornamental tree pruning
  , shrub trimming
  , or hedge shearing
  , our skilled team ensures each plant is properly cared for using industry-approved techniques. We tailor every service to the specific needs of your greenery—removing deadwood, encouraging healthy regrowth, and preserving natural form. Our eco-friendly approach focuses on enhancing plant vitality while ensuring clean lines and structure. Serving North Vancouver
  , West Vancouver
  , Burnaby
  , and beyond, we help residential and commercial properties stay lush, safe, and professionally maintained year-round. Trust BUR-HAN to keep your landscape thriving with precision pruning that supports both beauty and long-term plant health.
</p>

          </div>
        </section>
        <div className="banner-section">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <h3 className="heading" data-aos="fade-right">
                  "Clean Cuts, <span> Clean Results!"</span>
                </h3>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-left">
                <p className="text">
                  "Trust our professional pruning techniques to promote healthy plant growth, enhance structure,
                  and elevate the look of your entire landscape."
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy"
              src={softHedge}
              alt="Close-up of precisely shaped shrubs being pruned with sharp tools"
              title="Precise Shrub Shaping and Pruning"
              style={{ height: "42vw" }}
            />
          </div>
          <div className="text-container px-4" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
              Why Prune or Shear?
            </h3>
            <ul>
  <li>
    <strong>Healthier Plants:</strong> Pruning removes dead, diseased, or damaged branches that can drain nutrients from healthy parts of the plant. By eliminating these problem areas, trees and shrubs are able to redirect their energy toward stronger, healthier growth, improving overall plant vitality and resistance to pests and disease.
  </li>
  <li>
    <strong>Improved Appearance:</strong> Regular pruning ensures your landscape maintains clean lines, uniform shapes, and a well-manicured look. This boosts curb appeal and gives your outdoor space a polished, professional appearance—ideal for both residential properties and commercial landscapes in Vancouver and surrounding areas.
  </li>
  <li>
    <strong>Encourages Flowering:</strong> For flowering trees, shrubs, and perennials, strategic pruning can stimulate more abundant and vibrant blooms. By removing old or unproductive stems, new buds receive more sunlight and nutrients, resulting in healthier, longer-lasting flower cycles throughout the growing season.
  </li>
  <li>
    <strong>Safety:</strong> Overgrown branches and limbs can create hazards near walkways, driveways, fences, and utility lines. Our pruning services eliminate these risks by maintaining safe clearances and removing unstable limbs, helping to prevent property damage and injuries—especially during storms or high winds.
  </li>
  <li>
    <strong>Growth Control:</strong> Left unchecked, shrubs and hedges can quickly become overgrown, encroaching on paths, gardens, and other plantings. Pruning keeps growth under control, maintains desired shapes and sizes, and prevents overcrowding that can restrict airflow and light—both of which are essential to plant health.
  </li>
</ul>

          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
              Why Choose BUR-HAN for Pruning & Shearing?
            </h3>
            <ul>
              <li><strong>Expert Team:</strong> Our trained professionals use the correct techniques and timing to ensure your plants stay healthy and beautiful year-round.</li>
              <li><strong>Eco-Conscious Practices:</strong> We avoid unnecessary harsh chemicals and take care to preserve biodiversity.</li>
              <li><strong>Tailored Services:</strong> Every plant has unique needs—our services are customized to match the species, season, and setting.</li>
            </ul>
            <p style={{ paddingLeft: "1vw" }}>
              Whether you need seasonal pruning, structural shearing, or ongoing maintenance, BUR-HAN Garden & Lawn
              Care delivers precision and care with every cut.
            </p>
          </div>
          <div className="image-container px-3" data-aos="fade-left">
            <img loading="lazy"
              src={commercialLandscape}
              alt="Landscaping expert shearing hedges with professional equipment"
              title="Hedge Shearing by Landscaping Professionals"
            />
          </div>
        </section>
        <section className="section-container">
          <div className="text-container" style={{ flexBasis: "calc(90% - 0.5vw)", maxWidth: "calc(90% - 0.5vw)" }} data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
              Book Your Pruning Service with BUR-HAN Today
            </h3>
            <p>
              Keep your landscape fresh, tidy, and healthy with BUR-HAN’s professional pruning and shearing services.
              Serving Vancouver, North Vancouver, Burnaby, and West Vancouver, we help you maintain the beauty and
              vitality of your outdoor environment. Contact us for a quote tailored to your garden’s needs.
            </p>
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Garden Cleanup Services</h2>
          <div className="lawnCareLinks-grid">
            <a href="/services/garden-cleanups"><strong>Garden Cleanups</strong><span>All cleanup services</span></a>
            <a href="/services/garden-cleanups/leaf-cleanup"><strong>Leaf Cleanup</strong><span>Professional leaf removal</span></a>
            <a href="/services/garden-cleanups/garden-cleanup"><strong>Garden Cleanup</strong><span>Pruning, shearing & more</span></a>
            <a href="/services/garden-cleanups/garden-cleanup/pruning-shearing"><strong>Pruning & Shearing</strong><span>Shrub and hedge care</span></a>
            <a href="/services/garden-cleanups/garden-cleanup/blackberry-removal"><strong>Blackberry Removal</strong><span>Invasive plant control</span></a>
          </div>
        </section>
        <div className="secondBanner" style={{ marginTop: "0" }}>
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6 ">
                <h3 className="sndheading">
                  Get Started <span>Today!</span>
                </h3>
                <p>
                  Fill out our Get a Quote page, and let our expert landscaping
                  team bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs.
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Get A Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
